// extracted by mini-css-extract-plugin
module.exports = {"tag":"decrypt_tag__2lJgq"};